import React, {Component} from 'react';
import { connect } from 'react-redux'
import {Redirect} from 'react-router-dom';
import {addToCart} from '../ReduxActions/CartActions'
import ReactDOM from 'react-dom';
import {Container, Row, Col, Card, Image} from 'react-bootstrap'
import queryString from 'query-string';
import Typography from '@material-ui/core/Typography';
import MediaQuery from 'react-responsive';
import Truncate from 'react-truncate'
import '../stylesheets/ProductScreen.css'

// Date Picker
import 'date-fns'
import format from 'date-fns/format'
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';

// Country Select & Add to Cart
import {FormControl, Select, OutlinedInput, InputLabel, MenuItem, Button} from '@material-ui/core'

// Tabs
import {Tabs, Tab} from 'react-bootstrap'

// Expansion Panels
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// Components
import AddToCartModal from '../components/AddToCartModal';
import ErrorPopup from '../components/ErrorPopup';
import SuccessPopup from '../components/SuccessPopup';
import Loading from '../components/Loading';


class ProductScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      product: undefined,
      addOnProducts: undefined,
      StartDate: undefined,
      EndDate: undefined,
      variantValue: "",
      variantName: undefined,
      variantData: undefined,
      tabVal: 0,
      open: false,
      riderHeight: '',
      bikePedals: '',
      helmet: '',
      seatHeight: '',
      barReach: '',
      barDrop: '',
      modalError: false,
      modalErrorMessage: '',
      variantCartError: false,
      variantCarErrorMessage: '',
      successOpen: false,
    }

    this.fetchProduct = this.fetchProduct.bind(this)
    this.fetchVariants = this.fetchVariants.bind(this)
    this.fetchAddOns = this.fetchAddOns.bind(this)
  }

  componentDidMount() {
    this.setState({loading: true})
    console.log("Url: ", this.props.location.search);
    const urlObj = queryString.parse(this.props.location.search);
    console.log("url obj", urlObj);

    this.setState({
      StartDate: urlObj.start,
      EndDate: urlObj.end
    })

    this.fetchProduct();
    this.fetchVariants();
  }

  fetchProduct() {
    fetch('/api/getProduct', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: this.props.match.params.id
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log("got product: ", data.data[0])
      this.setState({ product: data.data[0] })
      this.fetchAddOns(data.data[0].city, data.data[0].country)
      setTimeout(() => {
        this.setState({loading: false})
      }, 800);
    })
  }

  fetchVariants() {
    fetch('/api/productVariant', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: this.props.match.params.id
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.count > 0) {
        this.setState({variantName: data.data[0].variant})
      }
      this.setState({ variantData: data.data })
    })
  }

  fetchAddOns(city, country) {
    fetch('/api/addOnProducts', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        city: city,
        country: country
      })
    })
    .then(response => response.json())
    .then(data => {
      this.setState({addOnProducts: data.products})
    })
  }

  handleDateChange = (name, date) => {
    console.log(date);
    this.setState({ [name]: date });

    console.log("formatted date: ", format(date, 'yyyy-MM-d 00:00:00'))
  };

  handleVariantChange = (e) => {
    console.log(e)
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value});
  }

  handleTabChange = (event, tabVal) => {
    this.setState({tabVal: tabVal})
  }


  /* BEGIN: Modal */
  handleModalChange = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.riderHeight === '') {
      // open error toast
      this.setState({ modalError: true, modalErrorMessage: " Must input your Height"})
    }
    else if (this.state.helmet === '') {
      // open error toast
      this.setState({ modalError: true, modalErrorMessage: " Must select a Helmet"})
    }
    else if (this.state.bikePedals === '') {
      // open error toast
      this.setState({ modalError: true, modalErrorMessage: " Must select Pedals"})
    }
    else {
      // Add to cart
      let sessionId = this.props.Auth.sessionId;
      let product = this.state.product;
      product['riderProfile'] = {
        riderHeight: this.state.riderHeight,
        helmet: this.state.helmet,
        bikePedals: this.state.bikePedals,
        barReach: this.state.barReach,
        barDrop: this.state.barDrop,
        seatHeight: this.state.seatHeight
      }
      product['variantName'] = this.state.variantName;
      product['variantValue'] = this.state.variantValue;
      console.log(product);
      this.props.dispatchAddToCart(product, sessionId);
      this.handleClose(e);
    }
  }

  handleOpen = (e) => {
    if (this.state.product.is_bike) {
      if (this.state.variantValue === '') {
        this.setState({ variantCartError: true, variantCarErrorMessage: "Must select " + this.state.variantName})
      }
      else {
        this.setState({ open: true })
      }
    }
    else {
      let sessionId = this.props.Auth.sessionId;
      let product = this.state.product;
      this.props.dispatchAddToCart(product, sessionId);
      this.setState({successOpen: true})
    }

  }

  // Close Add to Cart Modal
  handleClose = (e) => {
    e.preventDefault();
    this.setState({ open: false })
  }

  // Add to cart Success Snackbar
  handleSuccessClose = (e) => {
    this.setState({ successOpen: false })
  }

  // Close Add To Cart Modal Error Snackbar
  handleModalErrorClose = (event) => {
    this.setState({ modalError: false})
  }

  // Close Variant Cart Error Snackbar
  handleVariantErrorClose = (event) => {
    this.setState({ variantCartError: false })
  }
  /* END: Add To Cart Modal */

  render() {
    // let startDate = format(this.state.StartDate, 'yyyy-MM-d 00:00:00')
    var labelWidth = 0;
    if (this.InputLabelRef) {
      labelWidth=  ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth
    }

    console.log(this.props.Cart);
    const VariantForm = () => {
      if (this.state.product.is_bike && this.state.product.is_bike) {
        return (
          <div style={{marginTop: 10, marginBottom: 10}}>
            <FormControl className="material-form" variant="outlined">
              <InputLabel
                ref={ref => {
                  this.InputLabelRef = ref;
                }}
                htmlFor="outlined-variantValue-simple"
              >
                {this.state.variantName}
              </InputLabel>
              <Select
                value={this.state.variantValue}
                onChange={this.handleVariantChange}
                input={
                  <OutlinedInput
                    labelWidth={labelWidth}
                    name="variantValue"
                    id="outlined-variantValue-simple"
                  />
                }
              >
                {
                  this.state.variantData ?
                  this.state.variantData.map(item => (
                    <MenuItem key={item.variant_value} value={item.variant_value}>{item.variant_value}</MenuItem>
                  ))
                  : null
                }
              </Select>
            </FormControl>
          </div>
        )
      }
      else {
        return (<div style={{marginBottom: 10}}></div>)
      }
    }

    const ProductView = () => (
      <div className="product-border">
      <Container>
      <Row>
        <Col md={6} xs={12}>
          <Image fluid src={this.state.product.img_url} alt="Product" />
        </Col>
        <Col md={6} xs={12}>
          <div>
          <Typography variant="h2" >{this.state.product.title}</Typography>
          <Typography variant="subtitle1" style={{marginLeft: 3}} gutterBottom>{this.state.product.city}, {this.state.product.country}</Typography>
          <Typography style={{color: '#45b97c'}} variant="h5" gutterBottom>${this.state.product.price}.00</Typography>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', flex: 1}}>
            <div style={{flex: 0.5}}>
              <MuiPickersUtilsProvider className="material-form" utils={DateFnsUtils}>
                <DatePicker
                  className="material-form"
                  name="StartDate"
                  margin="normal"
                  variant="outlined"
                  label="Start Date"
                  value={this.state.StartDate}
                  onChange={this.handleDateChange.bind(null, "StartDate")}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div style={{flex: 0.5}}>
              <MuiPickersUtilsProvider className="material-form" utils={DateFnsUtils}>
                <DatePicker
                  className="material-form"
                  name="EndDate"
                  margin="normal"
                  variant="outlined"
                  label="End Date"
                  value={this.state.EndDate}
                  onChange={this.handleDateChange.bind(null, "EndDate")}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>
          <VariantForm />

          <div style={{marginBottom: 10}}>
            <Button disabled={!this.state.product.is_available} onClick={e => this.handleOpen(e)} style={{backgroundColor: "#45b97c", color: "white"}} size="large" className="material-form">Add To Cart</Button>
            {
              this.state.product.is_available ? null : <Typography variant="subheading" style={{textAlign: 'center', marginTop: 5, color: 'red'}} >Product Currently Unavailable</Typography>
            }

          </div>


        </Col>
      </Row>
    </Container>
    </div>
    )

    // @TODO Filter out the current product
    const AddOnProductsView = () => {
      if (this.state.addOnProducts) {
        return (      
          <div className="product-border" style={{marginTop: 20}}>
            <div style={{marginTop: 10, marginBottom: 5, marginLeft: 10}}><Typography variant="h4" style={{fontWeight: 500}}>ACCESSORIES</Typography></div>
            <div className="bottom-border" style={{marginBottom: 5}}></div>
            <div style={{display: 'flex', overflowY: 'auto'}}>
              {
              this.state.addOnProducts.map(item => (
                <Card key={item.title} className="productCard-screen">
                <Card.Img variant="top" className="addOnImg" src={item.img_url} />
                <Card.Body>
                  <Card.Title className="cardTitle-screen">
                    <Truncate lines={2}>{item.title}</Truncate>
                  </Card.Title>
                  {/* <Card.Text>
                    <Truncate lines={3}>{item.description}</Truncate>
                  </Card.Text> */}
                </Card.Body>
                <Card.Footer style={{alignItems: 'right'}} className="pull-right">
                  <Card.Text className="pull-right">${item.price}.00</Card.Text>
                </Card.Footer>
                </Card>
              ))
              }
            </div>
          </div>
        )
      }
      return null;
    }

    const HowItWorks = () => (
      <div>
        <p>Livelo provides the easiest way to enjoy a high-quality road bike during your time in {this.state.product ? this.state.product.city : null}.</p>
        <ul className="tab-li" style={{color: "#788188"}}>
          <li>Livelo supplies all of the equipment and accessories you could possibly need. </li>
          <li>Book your bike directly on our website or mobile app.</li>
          <li>Your bike will be delivered by Livelo to your hotel concierge the night prior to your ride.</li>
          <li>Simply return the bike to the hotel concierge when you are finished. </li>
          <li>Livelo can provide the best information on the greatest routes in the city.</li>
          <li>Livelo can also provide a local guide to make sure you have the easiest riding experience possible.</li>
          <li>We can also help you join a free group-ride based on your experience level. </li>
        </ul>
      </div>
    )

    const Tab1View = () => (
      <div style={{margin: 10}}>
        {
          this.state.product ? <p>{this.state.product.description}</p> : null
        }
      </div>
    )

    const Tab2View = () => (
      <div style={{margin: 10}}>
        {
          (this.state.product && this.state.product.is_bike) ? <HowItWorks /> : null
        }
      </div>
    )

    const Tab3View = () => (
      <div>
        <p style={{textAlign: 'center'}}>Tab 3</p>
      </div>
    )

    const ExpansionPanelsView = () => (
      <div style={{width: '100%'}}>
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Description</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          {
            this.state.product ? <Typography>{this.state.product.description}</Typography> : null
          }
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>How It Works</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div>
            <Typography>Livelo provides the easiest way to enjoy a high-quality road bike during your time in {this.state.product ? this.state.product.city : null}.</Typography>
            <ul className="tab-li" style={{color: "#646464"}}>
              <li>Livelo supplies all of the equipment and accessories you could possibly need. </li>
              <li>Book your bike directly on our website or mobile app.</li>
              <li>Your bike will be delivered by Livelo to your hotel concierge the night prior to your ride.</li>
              <li>Simply return the bike to the hotel concierge when you are finished. </li>
              <li>Livelo can provide the best information on the greatest routes in the city.</li>
              <li>Livelo can also provide a local guide to make sure you have the easiest riding experience possible.</li>
              <li>We can also help you join a free group-ride based on your experience level. </li>
            </ul>
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Sizing</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>

        </ExpansionPanelDetails>
      </ExpansionPanel>
      </div>
    )

    return (
      <div>
        {
          this.state.loading ? <Loading loading={this.state.loading} /> 
          :
          <div>
            <ProductView />
            <SuccessPopup open={this.state.successOpen} message="Successfully Added to your Cart" handleSuccessClose={this.handleSuccessClose.bind(this)} />
            <ErrorPopup hideDuration={6000} handleErrorClose={this.handleVariantErrorClose.bind(this)} errorMessage={this.state.variantCarErrorMessage} errorOpen={this.state.variantCartError} />
            <AddToCartModal open={this.state.open} modalError={this.state.modalError} errorMessage={this.state.modalErrorMessage} handleModalErrorClose={this.handleModalErrorClose.bind(this)} handleOpen={this.handleOpen.bind(this)} handleClose={this.handleClose.bind(this)} handleModalChange={this.handleModalChange.bind(this)} handleSubmit={this.handleSubmit.bind(this)} riderHeight={this.state.riderHeight} bikePedals={this.state.bikePedals} helmet={this.state.helmet} seatHeight={this.state.seatHeight} barReach={this.state.barReach} barDrop={this.state.barDrop}/>
            <div className="product-border">
              <MediaQuery minDeviceWidth={768}>
                <div style={{margin: 15}}>
                  <Tabs defaultActiveKey="tab1" id="uncontrolled-tab-example">
                    <Tab eventKey="tab1" title="Description">
                      <Tab1View />
                    </Tab>
                    <Tab eventKey="tab2" title="How It Works">
                      <Tab2View />
                    </Tab>
                    {
                      this.state.product.is_bike ?
                        <Tab eventKey="tab3" title="Bike Sizing">
                          <Tab3View />
                        </Tab>
                      : null
                    }
                  </Tabs>
                </div>
              </MediaQuery>
              <MediaQuery maxDeviceWidth={767}>
                <ExpansionPanelsView />
              </MediaQuery>
            </div>

            <AddOnProductsView />
          </div>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth,
    Cart: state.Cart
  }
}

const mapDispatchToProps = {
  dispatchAddToCart: (product, sessionId) => addToCart(product, sessionId)
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductScreen);